import React from 'react';
import { Container, Grid, Header,Image } from 'semantic-ui-react';

const Footer = () => (

    <Container fluid  style={{ backgroundColor : 'black', position : 'relative', bottom : 0,display : 'block',
  
    width : '100%'}}>
      <Grid divided inverted stackable>
        <Grid.Row>
    
        <Grid.Column width={16}>
            <Header inverted as='h4' content='&#9400;Totalenergies Coop' textAlign='center' />
            <Image   src= {'https://res.cloudinary.com/duknzdiyw/image/upload/v1670859271/coop/coop-logo_svvrp0.png'}  size ={'small'} centered/>
          </Grid.Column>
         
        </Grid.Row>
      </Grid>
  
    </Container>

);

export default Footer;
